import { HearAboutUs } from "../HearAboutUs";

export const HearAboutUsLabels = {
  [HearAboutUs.GoogleSearch]: "Google Search",
  [HearAboutUs.Facebook]: "Facebook",
  [HearAboutUs.Indeed]: "Indeed",
  [HearAboutUs.Instagram]: "Instagram",
  [HearAboutUs.LinkedIn]: "LinkedIn",
  [HearAboutUs.Seek]: "Seek",
  [HearAboutUs.UniOpenDay]: "Uni / Open day",
  [HearAboutUs.SchoolDailyOrganiser]: "School daily organiser",
  [HearAboutUs.FriendOrColleague]: "Friend or colleague",
  [HearAboutUs.Other]: "Other",
} as const;
